export default __webpack_public_path__ + "img/0ec186f62f48af077ddacf0fbfbaec61.png";